import {
    I18nFormatArgs,
    I18nReacher,
    Plan,
    resizedUrl,
    useTheme,
} from '@springbig/shared';
import { VStack, Box, Image } from 'native-base';
import React from 'react';
import { Caption, H3, H2 } from '~/shared/Typography';
import PlanBenefits from '~/pages/subscriptions/components/PlanBenefits';
import { faGem } from '@fortawesome/free-regular-svg-icons';
import { SpIcon } from '~/shared/Icon';
import { Card, Button } from '~/shared/Theme';

type PlanDetailsProps = {
    plan: Plan;
    onCancel: () => void;
    onProceed: () => void;
};

type Schedule = {
    text: I18nReacher,
    textValues: I18nFormatArgs,
};

type Billing = {
    both: Schedule,
    monthly: Schedule,
    yearly: Schedule,
};

const PlanDetails = ({
    plan,
    onCancel,
    onProceed
}: PlanDetailsProps) => {

    const {
        primary,
        radius_md,
    } = useTheme();

    const billing: Billing = {
        both: {
            text: 'subscriptions.billing.both',
            textValues: [plan.recurring_amount.toFixed(2), plan.yearly_recurring_amount.toFixed(2)],
        },
        monthly: {
            text: 'subscriptions.billing.monthly',
            textValues: [plan.recurring_amount.toFixed(2)],
        },
        yearly: {
            text: 'subscriptions.billing.yearly',
            textValues: [plan.yearly_recurring_amount.toFixed(2)],
        },
    };

    return (
        <VStack
            justifyContent={'center'}
            textAlign={'center'}
            space={plan.plan_description_type === 'image' ? 4 : 8}
            py={4}
            px={4}
        >
            <H3 text={'subscriptions.details.title'} />

            <Box alignSelf={'center'}>
                <SpIcon
                    color={primary}
                    icon={faGem}
                    size={36}
                />
            </Box>

            <Caption text={'subscriptions.details.description'} />

            <VStack>
                <H3 text={'subscriptions.pricing_title'} />
                { plan.trial_period > 0 &&
                    <Caption
                        text={'subscriptions.free_trial'}
                        textValues={[plan.trial_period]}
                    />
                }
                <Caption>
                    <Caption
                        text={billing[plan.billing_schedule].text}
                        textValues={billing[plan.billing_schedule].textValues}
                    />
                    <Caption text={'subscriptions.pricing'} />
                </Caption>
            </VStack>

            { plan.plan_description_type === 'image' ?
                <Box rounded={radius_md} overflow={'hidden'}>
                    <img
                        src={resizedUrl(plan?.plan_description_image?.src, 9999, 480, 'inside')}
                        width={'100%'}
                        loading='lazy'
                    />
                </Box>
                :
                <Card>
                    <H2
                        color={primary}
                        textAlign={'center'}
                    >
                        { plan.name }
                    </H2>
                    <PlanBenefits plan={plan} alignItems={'flex-start'} />
                </Card>
            }

            <VStack space={plan.plan_description_type === 'image' ? 4 : 8}>
                <Button
                    onPress={onProceed}
                    text={plan.trial_period > 0 ? 'subscriptions.details.try_free_button' : 'subscriptions.details.try_button'}
                />

                <Button
                    variant={'neutral'}
                    onPress={onCancel}
                    text={'subscriptions.back_button'}
                />
            </VStack>
        </VStack>
    );
};

export default PlanDetails;
